export class MixDesignConstituent {
  constructor(data) {
    this.order = data.order;
    this.byPercent = data.byPercent;
    this.quantity = data.quantity;
    this.batchCode = data.batchCode;
    this.batchDescription = data.batchDescription;
    this.batchShortDescription = data.batchShortDescription;
    this.constituentItemId = data.id;
    this.constituentItemCode = data.code;
    this.constituentItemDescription = data.description;
    this.constituentItemShortDescription = data.shortDescription;
    this.unitCode = data.batchUnitCode;
    this.unitId = data.batchUnitId;
    this.unitSymbol = data.batchUnitSymbol;
  }
}
